<template>
    <v-card
        v-else
        class="report-card"
        elevation="0"
    >
        <report-card-title
            :report="report"
            :type="type"
        />

        <v-card-text>
            <v-row>
                <v-col md="6" cols="12" sm="12" class="px-0 py-0">
                    <v-list>
                        <v-list-item>
                            <v-list-item-title class="report__title-item label">
                                {{ `${$t('reports.status')}:` }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="report__subtitle-item body-text">
                                <v-chip
                                    :color="getReportStatusBadgeColor()"
                                    label
                                    small
                                    text-color="white"
                                >
                                    {{ $t(`reports.statuses.${reportStatus}`) }}
                                </v-chip>
                            </v-list-item-subtitle>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-title class="report__title-item label">
                                {{ `${$t('reports.report_type')}:` }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="report__subtitle-item body-text">
                                {{ $t(`reports.types.${reportTypeRouteParameter}`) }}
                            </v-list-item-subtitle>
                        </v-list-item>

                        <v-list-item v-if="reportHaveProgram">
                            <v-list-item-title class="report__title-item label">
                                {{ `${$t('reports.program')}:` }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="report__subtitle-item body-text">
                                {{ reportProgramsAbbreviation }}
                            </v-list-item-subtitle>
                        </v-list-item>

                    </v-list>
                </v-col>

                <v-col md="6" cols="12" sm="12" class="px-0 py-0">
                    <v-list>
                        <v-list-item>
                            <v-list-item-title class="report__title-item label">
                                {{ `${$t('reports.created_at')}:` }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="report__subtitle-item body-text">
                                {{ reportCreationDate }}
                            </v-list-item-subtitle>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-title class="report__title-item label">
                                {{ `${$t('reports.generated_by')}:` }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="report__subtitle-item body-text">
                                {{ reportUserGenerator }}
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import ReportCardTitle from "./ReportCardTitle";
import _ from "lodash";

export default {
    name: "ReportCard",

    components: {ReportCardTitle},

    props: {
        report: {
            type: Object,
            required: true,
        },
        type: {
            type: Object,
            required: true,
        },
    },

    methods: {
        /**
         *
         * @returns {*}
         */
        getReportStatusBadgeColor() {
            let colorsByStatus = {
                IN_PROCESS: 'primary',
                GENERATED: 'success',
                IN_REVIEW: 'warning',
                DEPRECATED: 'secondary',
                FAILED: 'error',
                CLOSED: 'blue-grey',
            }

            return colorsByStatus[this.reportStatus];
        },
    },

    computed: {
        /**
         *
         * @returns {*}
         */
        reportStatus() {
            return _.get(this.report, 'status');
        },

        /**
         *
         * @returns {*}
         */
        reportType() {
            return _.get(this.report, 'report_type.name');
        },

        /**
         *
         * @returns {*}
         */
        reportCreationDate() {
           return _.get(this.report, 'created_at').slice(0, 10);
        },

        /**
         *
         * @returns {*}
         */
        reportUserGenerator() {
            return _.get(this.report, 'user.username');
        },

        /**
         *
         * @returns {*}
         */
        reportProgramsAbbreviation() {
            return _.get(this.report, 'program.abbreviation');
        },

        /**
         *
         * @returns {*}
         */
        reportTypeRouteParameter() {
            return _.get(this.type, 'route_type_parameter');
        },

        /**
         *
         * @returns boolean
         */
        reportHaveProgram (){
            return !_.isNull(this.report.program);
        },

    },
}
</script>

<style scoped>
    .report__title-item {
        max-width: 150px;
        margin-bottom: 5px;
    }
    .report__subtitle-item {
        margin-bottom: 5px;
        color: hsl(212deg, 18%, 17%) !important;
    }
</style>
